import { DEFENDER_TYPE } from '@models/DefenderType';
import { WizardDefender } from './WizardDefender';
import { RangerDefender } from './RangerDefender';
var DefenderFactory = /** @class */ (function () {
    function DefenderFactory() {
    }
    DefenderFactory.createDefender = function (defenderType, gridPositionX, gridPositionY) {
        switch (defenderType) {
            case DEFENDER_TYPE.WIZARD:
                return new WizardDefender(gridPositionX, gridPositionY);
            case DEFENDER_TYPE.RANGER:
                return new RangerDefender(gridPositionX, gridPositionY);
            default:
                return new RangerDefender(gridPositionX, gridPositionY);
        }
    };
    return DefenderFactory;
}());
export { DefenderFactory };
